export default __webpack_public_path__ + "static/media/fastclix_lancets@3x.feb562b7.webp";